import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import NotFound from "../../components/not-found/NotFound";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import {
  catchMessage,
  elseMessage,
  successMessage,
} from "../../comman/Message";
import {
  DatePicker,
  DatePickerInput,
  Select,
  capitalizeFirstLetter,
  dateFormat,
  searchDateFormat,
} from "../../components/Form";
import { deleteMeetupsApi, getMeetupsListApi } from "../../services/meetups";
import { IconButton } from "@mui/material";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useDebounce from "../../hooks/useDebounce";
import { SecondaryButton } from "../../components/Button/Button";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import Switch from "../../components/Switch/Switch";
import ChangeMeetupsStatus from "./ChangeMeetupsStatus";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ModalBox from "../../components/modal/ModalBox";
import { ViewIcon } from "../../comman/action/ViewIcon";
import { PaginationShow } from "../../comman/action/Pagination";

const MeetupsManagement = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  let searchStatus = searchParam.get("status") || "";
  let searchType = searchParam.get("type") || "";
  let searchStartDate = searchParam.get("startDate") || "";
  let searchEndDate = searchParam.get("endDate") || "";
  let searchEventStartDate = searchParam.get("eventStartDate") || "";
  let searchEventEndDate = searchParam.get("eventEndDate") || "";
  const [search, setSearch] = useState(searchParam.get("query") || "");
  let debounceValue = useDebounce(search || "", 300);

  // const [orderByName, setOrderByName] = useState('');
  const [orderByMember, setOrderByMember] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [direction, setDirection] = useState("ASC");
  const [meetupsList, setMeetupsList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [statusModal, setStatusModal] = useState(false);
  const [statusValue, setStatusValue] = useState("");
  const [statusName, setStatusName] = useState("");
  const [statusId, setStatusId] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [titleName, setTitleName] = useState("");
  //-----------handle-pagination--------------
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };
  //*********Handel status********* */
  const statusUpdateHandler = (id, status, name) => {
    setStatusModal(true);
    setStatusId(id);
    setStatusValue(status);
    setStatusName(name);
  };
  //--------------delete-handler------------------------
  const deleteHandler = (id, name) => {
    setDeleteModal(true);
    setDeleteId(id);
    setTitleName(name);
  };
  //-----------search-status--------------
  const handleStatus = (event) => {
    searchParam.set("page", 1);
    searchParam.set("status", event.target.value);
    setSearchParam(searchParam);
  };
  //-----------search-type--------------
  const handleType = (event) => {
    searchParam.set("page", 1);
    searchParam.set("type", event.target.value);
    setSearchParam(searchParam);
  };
  //-----------search-start-date--------------
  const handleStartDate = (date) => {
    searchParam.set("page", 1);
    searchParam.set("startDate", searchDateFormat(date));
    setSearchParam(searchParam);
  };
  //-----------search-end-date--------------
  const handleEndDate = (date) => {
    searchParam.set("page", 1);
    searchParam.set("endDate", searchDateFormat(date));
    setSearchParam(searchParam);
  };
  const handleEventStartDate = (date) => {
    searchParam.set("page", 1);
    searchParam.set("eventStartDate", searchDateFormat(date));
    setSearchParam(searchParam);
  };
  //-----------search-end-date--------------
  const handleEventEndDate = (date) => {
    searchParam.set("page", 1);
    searchParam.set("eventEndDate", searchDateFormat(date));
    setSearchParam(searchParam);
  };
  //-----------refresh-handler--------------
  const refreshHandler = () => {
    setSearch("");
    searchParam.delete("status");
    searchParam.delete("type");
    searchParam.delete("startDate");
    searchParam.delete("endDate");
    searchParam.delete("eventStartDate");
    searchParam.delete("eventEndDate");
    setSearchParam(searchParam);
  };
  //--------------sorting-name------------------------
  const orderByNameFun = () => {
    const newDirection = orderByMember === "ASC" ? "DESC" : "ASC";
    setOrderByMember(newDirection);
    setFieldName("totalMembers");
    setDirection(newDirection);
  };
  const orderByName = () => {
    const newDirection = orderByMember === "ASC" ? "DESC" : "ASC";
    setOrderByMember(newDirection);
    setFieldName("interestedCount");
    setDirection(newDirection);
  };
  //----------------delete-hashtag--------------------------
  const deleteMeetups = async () => {
    try {
      const res = await deleteMeetupsApi(deleteId);
      if (res?.data?.status === 200) {
        setDeleteModal(false);
        getMeetupsList();
        successMessage(res);
      } else {
        elseMessage(res);
      }
    } catch (err) {
      catchMessage(err);
    }
  };
  //------------------listing-Api----------------------------------
  const getMeetupsList = async (
    page = activePage,
    search = debounceValue,
    sortField = fieldName,
    sortDirection = direction,
    meetupStatus = searchStatus,
    categoryType = searchType,
    startDate = searchStartDate,
    endDate = searchEndDate,
    eventStartDate = searchEventStartDate,
    eventEndDate = searchEventEndDate
  ) => {
    try {
      setMeetupsList([]);
      showLoader();
      const res = await getMeetupsListApi({
        page,
        search,
        sortField,
        sortDirection,
        meetupStatus,
        categoryType,
        startDate,
        endDate,
        eventStartDate,
        eventEndDate,
      });
      if (res?.data?.status === 200) {
        setMeetupsList(res?.data?.data?.Meetup || []);
        setTotal(res?.data?.data?.total || 0);
        hideLoader();
      } else {
        elseMessage(res);
        setMeetupsList([]);
        hideLoader();
      }
    } catch (err) {
      catchMessage(err);
      hideLoader();
    }
  };
  useEffect(() => {
    if (debounceValue) {
      searchParam.set("query", debounceValue);
    } else {
      searchParam.delete("query");
    }
    if (activePage === 1) {
      searchParam.delete("page");
    }
    if (!searchStatus) {
      searchParam.delete("status");
    }
    if (!searchType) {
      searchParam.delete("type");
    }
    setSearchParam(searchParam);
    getMeetupsList(
      activePage,
      debounceValue,
      fieldName,
      direction,
      searchStatus,
      searchType
    );
  }, [
    activePage,
    debounceValue,
    fieldName,
    direction,
    searchStatus,
    searchType,
  ]);
  useEffect(() => {
    if (
      (searchStartDate && searchEndDate) ||
      (searchStartDate === "" && searchEndDate === "") ||
      (searchStartDate === null && searchEndDate === null)
    ) {
      getMeetupsList(
        activePage,
        debounceValue,
        fieldName,
        direction,
        searchStatus,
        searchType,
        searchStartDate,
        searchEndDate,
        searchEventStartDate,
        searchEventEndDate
      );
    }
    if (!searchStartDate) {
      searchParam.delete("startDate");
    }
    if (!searchEndDate) {
      searchParam.delete("endDate");
    }
    if (!searchEventStartDate) {
      searchParam.delete("eventStartDate");
    }
    if (!searchEventEndDate) {
      searchParam.delete("eventEndDate");
    }
  }, [
    searchStartDate,
    searchEndDate,
    searchEventStartDate,
    searchEventEndDate,
  ]);
  useEffect(() => {
    if (search) {
      searchParam.set("page", 1);
    }
  }, [search]);
  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">Meetups Management</h4>
          </div>
          <div className="FilterBox FilterArea cstm_set_scroll">
            <div className="form-group search_md">
              <input
                type="search"
                className="form-control"
                placeholder="Search community name,event name"
                value={search || ""}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            {/* --------select-status---------- */}
            <div className="form-group select_width">
              <Select
                className={`form-control ${
                  searchStatus === "" ? "text-secondary" : "text-dark"
                }`}
                value={searchStatus}
                onChange={handleStatus}
              >
                <option value="">Select status</option>
                <option value="upComing">UpComing</option>
                <option value="cancelled">Cancelled</option>
                <option value="compeleted">Completed</option>/
              </Select>
            </div>
            {/* --------select-meetups-type---------- */}
            <div className="form-group select_width">
              <Select
                className={`form-control ${
                  searchType === "" ? "text-secondary" : "text-dark"
                }`}
                value={searchType}
                onChange={handleType}
              >
                <option value="">Select Meetup Type</option>
                <option value="virtual">Virtual</option>
                <option value="physical">Physical</option>
              </Select>
            </div>
            <div className="form-group date_picker">
              <DatePicker
                className="form-control "
                name="startDate"
                selected={searchStartDate}
                placeholder="Start Date"
                onChange={(date) => handleStartDate(date)}
                maxDate={searchEndDate}
              />
            </div>
            <div className="form-group date_picker">
              <DatePicker
                name="endDate"
                className="form-control"
                placeholder="End Date"
                selected={searchEndDate}
                onChange={(date) => handleEndDate(date)}
                minDate={searchStartDate}
              />
            </div>
            {/* <div className="form-group date_picker">
              <DatePicker
                className="form-control "
                name="startDate"
                selected={searchEventStartDate}
                placeholder="Event Start Date"
                onChange={(date) => handleEventStartDate(date)}
                // maxDate={searchEventEndDate}
              />
            </div> */}
            <div className="form-group width-custm">
              <DatePickerInput
                className="form-control password"
                name="Date"
                selected={searchEventStartDate}
                placeholder="Event Start Date"
                onChange={(date) => handleEventStartDate(date)}
                maxDate={searchEventEndDate}
                // error={schedulerError.Date}
              />
            </div>
            {/* <div className="form-group date_picker">
              <DatePicker
                name="endDate"
                className="form-control"
                placeholder="Event End Date"
                selected={searchEventEndDate}
                onChange={(date) => handleEventEndDate(date)}
                minDate={Date.now()}
              />
            </div> */}
            <div className="form-group width-custm">
              <DatePickerInput
                className="form-control password"
                name="Date"
                selected={searchEventEndDate || ""}
                placeholder="Event End Date"
                onChange={(date) => handleEventEndDate(date)}
                minDate={searchEventStartDate}
                // error={schedulerError.Date}
              />
            </div>
            <div className="form-group refresh_button">
              <SecondaryButton onClick={refreshHandler}>
                <RotateLeftIcon />
              </SecondaryButton>
            </div>
          </div>
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Community Name</th>

                  <th> Event Name </th>

                  <th>
                    <div className="sorting-th" onClick={orderByName}>
                      <span>Interested Members</span>
                      {orderByMember === "ASC" ? (
                        <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                      ) : (
                        <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                      )}
                    </div>
                  </th>
                  <th>
                    <div className="sorting-th" onClick={orderByNameFun}>
                      <span>Members</span>
                      {orderByMember === "ASC" ? (
                        <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                      ) : (
                        <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                      )}
                    </div>
                  </th>
                  <th>Create Date</th>
                  <th>Event Date</th>
                  <th>Status</th>
                  <th>Type</th>
                  <th className="text-center"> Action </th>
                </tr>
              </thead>
              <tbody>
                {meetupsList.length > 0 ? (
                  meetupsList.map(
                    (
                      {
                        categoryType,
                        createdAt,
                        meetupStatus,
                        interestedCount,
                        communityName,
                        eventDate,
                        eventName,
                        _id,
                        totalMembers,
                        status,
                      },
                      index
                    ) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{++index + (activePage - 1) * 10}</td>
                            <td>{communityName || "N/A"}</td>
                            <td>{eventName || "N/A"}</td>

                            <td>
                              {interestedCount
                                ? `${interestedCount} member`
                                : "0 member"}
                            </td>
                            <td>
                              {totalMembers
                                ? `${totalMembers} member`
                                : "0 member"}
                            </td>
                            <td>{dateFormat(createdAt)}</td>
                            <td>{dateFormat(eventDate)}</td>
                            <td>
                              {capitalizeFirstLetter(meetupStatus) || "N/A"}
                            </td>
                            <td>
                              {capitalizeFirstLetter(categoryType) || "N/A"}
                            </td>
                            <td>
                              <div className="d-flex justify-content-center">
                                <Switch
                                  checked={status}
                                  onChange={() =>
                                    statusUpdateHandler(_id, status, eventName)
                                  }
                                />
                                <ViewIcon
                                  to={`/meetups-management/view-details/${_id}`}
                                />

                                <IconButton
                                  onClick={() => deleteHandler(_id, eventName)}
                                >
                                  <DeleteForeverIcon
                                    sx={{ color: "red", fontSize: 26 }}
                                  />
                                </IconButton>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    }
                  )
                ) : (
                  <NotFound
                    cols={10}
                    msg="No Meetups Found!"
                    icon={<GroupsOutlinedIcon sx={{ fontSize: 48 }} />}
                  />
                )}
              </tbody>
            </table>
          </div>
          <PaginationShow
            total={total}
            activePage={activePage}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
      <ChangeMeetupsStatus
        show={statusModal}
        close={() => setStatusModal(false)}
        id={statusId}
        status={statusValue}
        listing={getMeetupsList}
        name={statusName}
      />
      {/* --------delete-meetups-modal---------- */}
      <ModalBox
        status={deleteModal}
        onClose={() => setDeleteModal(false)}
        title="Delete Meetups"
        description={
          <span>
            Do you want to Delete <strong>{titleName}</strong> ?
          </span>
        }
        action={deleteMeetups}
      />
    </>
  );
};
export default MeetupsManagement;
